import * as React from 'react';

export const Excel = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M9.954 0l4.142 4.232-.001 10.325c0 .75-.572 1.367-1.304 1.436l-.14.007H3.345c-.751 0-1.367-.572-1.437-1.304l-.007-.139V1.454C1.9.704 2.472.088 3.204.02l.14-.007h6.045L9.954 0zM9.39 1.295H3.344a.16.16 0 0 0-.153.109l-.008.05v13.103c0 .07.045.13.11.152l.05.008h9.309a.16.16 0 0 0 .152-.11l.008-.05v-9.76H9.39V1.295zM6.948 6.548l1.05 1.55 1.049-1.55h1.77L8.883 9.406l2.328 3.439H9.44l-1.443-2.131-.754 1.114h.763l.626 1.017H4.784l2.328-3.439-1.935-2.858h1.771z"
    />
  </svg>
);
